class DetailsDisclosure extends HTMLElement {
  constructor() {
    super();
    this.mainDetailsToggle = this.querySelector("details");
    this.content =
      this.mainDetailsToggle.querySelector("summary").nextElementSibling;

    this.mainDetailsToggle.addEventListener(
      "focusout",
      this.onFocusOut.bind(this)
    );
    this.mainDetailsToggle.addEventListener("toggle", this.onToggle.bind(this));
  }

  onFocusOut() {
    setTimeout(() => {
      if (!this.contains(document.activeElement)) this.close();
    });
  }

  onToggle() {
    if (!this.animations) this.animations = this.content.getAnimations();

    if (this.mainDetailsToggle.hasAttribute("open")) {
      this.animations.forEach((animation) => animation.play());
    } else {
      this.animations.forEach((animation) => animation.cancel());
    }
  }

  close() {
    this.mainDetailsToggle.removeAttribute("open");
    this.mainDetailsToggle
      .querySelector("summary")
      .setAttribute("aria-expanded", false);
  }
}

customElements.define("details-disclosure", DetailsDisclosure);

class HeaderMenu extends DetailsDisclosure {
  constructor() {
    super();
    this.header = document.querySelector(".header-wrapper");
    this.overlay = document.getElementById("mega-menu-overlay");

    // Check if hover dropdown is enabled
    this.hoverEnabled = this.hasAttribute("data-hover-enabled");

    // Check if this is a mega menu
    const details = this.querySelector("details");
    const isMegaMenu =
      details && details.classList.contains("mega-menu--details");

    if (this.hoverEnabled) {
      if (isMegaMenu) {
        // Mega menus get full hover functionality with animations
        this.setupHoverEvents(true);
      } else {
        // Regular dropdowns get hover functionality without animations
        this.setupHoverEvents(false);
      }
    }
  }

  setupHoverEvents(withAnimations = true) {
    const summary = this.querySelector("summary");
    const details = this.querySelector("details");

    // Open on mouseenter
    summary.addEventListener("mouseenter", () => {
      if (!details.hasAttribute("open")) {
        details.setAttribute("open", "");
        summary.setAttribute("aria-expanded", "true");
        if (withAnimations) {
          this.showOverlay();
        }
      }
    });

    // Close on mouseleave (with delay to match CSS animation duration)
    let closeTimeout;
    this.addEventListener("mouseleave", () => {
      closeTimeout = setTimeout(
        () => {
          if (details.hasAttribute("open")) {
            details.removeAttribute("open");
            summary.setAttribute("aria-expanded", "false");
            if (withAnimations) {
              this.hideOverlay();
            }
          }
        },
        withAnimations ? 150 : 50
      ); // Faster close delay for regular dropdowns
    });

    // Cancel close timeout if mouse re-enters
    this.addEventListener("mouseenter", () => {
      if (closeTimeout) {
        clearTimeout(closeTimeout);
        closeTimeout = null;
      }
    });

    // Only prevent default click behavior if we're in hover mode
    // This allows normal click behavior to work when needed
    summary.addEventListener("click", (e) => {
      // Don't prevent default - let the normal click behavior work
      // The hover will handle opening, and clicks can still work for accessibility
    });
  }

  showOverlay() {
    if (this.overlay) {
      // Use requestAnimationFrame to ensure smooth transition
      requestAnimationFrame(() => {
        this.overlay.classList.add("active");
      });
    }
  }

  hideOverlay() {
    if (this.overlay) {
      // Use requestAnimationFrame to ensure smooth transition
      requestAnimationFrame(() => {
        this.overlay.classList.remove("active");
      });
    }
  }

  onToggle() {
    if (!this.header) return;
    this.header.preventHide = this.mainDetailsToggle.open;

    // Show/hide overlay based on menu state
    if (this.mainDetailsToggle.open) {
      this.showOverlay();
    } else {
      this.hideOverlay();
    }

    if (
      document.documentElement.style.getPropertyValue(
        "--header-bottom-position-desktop"
      ) !== ""
    )
      return;
    document.documentElement.style.setProperty(
      "--header-bottom-position-desktop",
      `${Math.floor(this.header.getBoundingClientRect().bottom)}px`
    );
  }
}

customElements.define("header-menu", HeaderMenu);
